// =============================================================================
// OZELLIK ANAHTARLARI
// =============================================================================

// "Benzer Sonda Sec" ve "Benzer Profil" ile veri GETIRME.
//   true  -> benzer sonda secilince o sondanin tum verisi forma kopyalanir;
//            benzer profil numarasi girilince eğim, arazi kullanimi, tas,
//            urun, cakil, kaya, su erozyonu, drenaj ve ilce profilden dolar.
//   false -> hicbir veri getirilmez; kullanici her alani kendisi girer.
//            Kontrol sondasinin hangi ornek sondaya bagli oldugu bilgisi
//            (benzer_sonda_no) YINE kaydedilir: sonda izah cetveli kontrol
//            sondalari bu bilgiye gore yerlestiriyor.
// Musteri talebiyle 2026-09-25'te KAPATILDI.
export const BENZER_VERI_GETIR = false;
